export const colors = {
  adobeRed: 'rgb(217, 43, 47)', // #d92b2f
  black: 'rgb(0, 0, 0)',
  textColor: 'rgb(0, 0, 0, 0.87)', //#000000
  black1: 'rgba(0, 0, 0, 0.40)',
  blackMineShaft: 'rgb(40, 40, 40)', // #282828
  blue: 'rgb(4, 145, 255)', // #0491ff
  blueLight: 'rgb(0, 122, 254)', // #007afe
  blueLight1: 'rgb(160,160,255)', // #a0a0ff
  blue1: 'hsl(208, 100%, 97%)', //#f0f8ff
  blue2: 'hsl(208, 100%, 90%)', //#f0f8ff
  blue3: 'rgb(0,103,197)', // #0067C5
  cancelButton: 'rgb(87, 87, 87)', // #575757
  cardTitle: 'rgb(95,95,95)', // #8b8b8b
  darkBlue: 'rgb(0,82,204)', // #0052cc
  darkGreen: 'rgb(0,102,68)', // #006644
  darkPurple: 'rgb(82,67,170)', // #0052cc
  fieldsBorderGray: 'rgba(179, 179, 179, 1)', // #b3b3b3
  linesGray: 'rgba(151, 151, 151, 0.2)',
  primary: 'rgb(243, 109, 42)', // #f36d2a
  lightPrimary: 'rgb(243, 109, 42, 0.1)', // #f36d2a
  btnDisabled: 'rgb(243, 109, 42, 0.5)', // #f36d2a
  red: 'rgb(217, 43, 47)', // #D92B2F
  redCancel: 'rgb(192, 0, 0)', // #c00000
  subTitle: 'rgb(95,95,95)', // #5f5f5f
  lightTitle: 'rgb(139,139,139)', // #8b8b8b
  text: 'rgb(139, 139, 139)', // 3a3a3a
  darkText: 'rgb(58,58,58)', // 3a3a3a -Actual 3a3a3a
  darkerGray: 'rgb(237, 237, 237)', // #ededed
  textGray: 'rgba(0, 0, 0, 0.38)',
  title: 'rgb(45, 45, 45)', // '#2d2d2d'
  white: 'rgb(255, 255, 255)',
  productionChip: 'rgb(255,93,97)',
  concertChip: 'rgb(0,155,78)',
  contentDivider: 'rgb(151,151,151,0.2)', // '#979797',
  linkHover: 'rgb(23, 77, 120)', // '#174d78',
  primaryTitleColor: 'rgb(47, 47, 47)', // '#2f2f2f',
  secondaryTitleColor: 'rgb(54, 54, 54)', // '#363636',
  rose: 'rgb(255,145,145)', // #ff9191
  websiteLinkColor: 'rgb(60, 60, 60)', // '#3c3c3c',
  websiteLinkColorBg: 'rgb(216, 216, 216, 0.2)', // '#d8d8d8',
  gray: 'rgb(58, 58, 58, 0.5)', // '#3a3a3a',
  grey: 'rgb(234, 234, 234)', // #eaeaea
  purple: 'rgb(173, 25, 25)', // #ad1919
  lightGreen: 'rgb(109, 212, 0)', // #6dd400
  purpleLight: 'rgb(222, 122, 122)', // #de7a7a
  orange: 'rgb(253, 124, 40)', // #fd7c28
  grey4: 'hsl(0, 0%, 44%)',
  background: {
    biscue: 'rgb(238,225,219)', // #eee1db
    dark: 'rgb(240, 240, 240)',
    default: 'rgb(250, 250, 250)',
    gray: 'rgb(238, 238, 238)', // #eeeeee
    grayCard: 'rgb(245, 245, 245)', // #f5f5f5
    grayLight: 'rgb(248, 248, 248)', // #f8f8f8
    optionBg: 'rgb(0, 0, 0, 0.04)', // #f8f8f8
    grayIcon: 'rgb(221,221,221)', // #dddddd
    gradiant: 'repeating-linear-gradient(-65deg, #b46060, #b46060 5px, rgb(110,6,6,0.7) 5px, rgb(110,6,6,0.7) 10px)',
    blue: 'rgba(0, 103, 197, 0.1)',
  },
  grey1: 'rgb(127, 127, 127)', // #7f7f7f,
  grey2: 'rgb(111, 111, 111)', // #6f6f6f,
  blockIcon: 'rgb(216, 77, 77)', // #d84d4d
  grey3: 'rgb(58, 58, 58)', // #3a3a3a
  greenChip: 'rgb(6, 110, 15)', //#066e0f
  blueChip: 'rgb(0, 103, 197)', //#0067c5
  primary2: 'rgb(194, 87, 36)',
  border: {
    grey: 'rgb(235,235,235)', // ebebeb
    grey1: 'rgb(223, 223, 223)', // dfdfdf
  },
  darkGrey: 'rgb(116,119,118)', // #747776
  green: 'rgb(101, 137, 1)', // #658901
  lightBlack: 'rgba(0, 0, 0, 0.52)',
  fbBlue: 'rgb(59,87,163)', // #3B57A3
  lightPink: 'rgb(253,245,245)', // fdf5f5
  lightGrey: 'rgb(250, 250, 250)', //#fafafa
  orange2: 'rgb(249,112,46)', //F9702E
  yellow: 'rgb(255, 204, 0)', // #FFCC00
  clearGray: 'rgba(0, 0, 0, 0.6)',
  yellowLight: 'rgb(253, 247, 227)', // #FDF7E3
};

export const fontSize = {
  basic: 16,
  large: 18,
  medium: 14,
  h2: 28,
  h3: 24,
  h6: 20,
  regularTitle: 16,
  smallTitle: 12,
  subTitle: '2.67rem',
  table: 13,
  textFieldLabel: 13,
  title: 32,
  largeTitle: '2rem',
  mdTitle: '1.5rem',
  description: 15,
  heading: 26,
};

export const lineHeight = 1.73;

export const newLineHeight = 1.43;

export const letterSpacing = {
  subTitle: 2.25,
};

export const borderRadius = {
  fields: 2.5,
  button: 2,
  input: 4,
};

export const boxShadows = {
  block: '0 2px 6px 0 rgba(151, 151, 151, 0.35)',
  sideCard: '0 2px 9px 0 rgba(0, 0, 0, 0.1)',
  card: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
  table: '0 1px 7px 0 rgba(180, 180, 180, 0.5)',
};

export const border = {
  lightGrey: 'solid 0.5px rgba(151, 151, 151, 0.5)',
  input: `1px solid ${colors.fieldsBorderGray}`,
};

export const formBlock = {
  backgroundColor: colors.background.grayLight,
  borderRadius: borderRadius.button,
  boxShadow: boxShadows.block,
  padding: 20,
};

export const inputSubmitStyles = {
  borderRadius: 2,
  WebkitAppearance: 'none',
  backgroundColor: colors.primary,
  color: colors.white,
  border: 'none',
  fontFamily: 'Roboto',
  fontSize: 15,
  fontWeight: 'bold',
  fontStyle: 'normal',
  letterSpacing: 0,
  padding: 7,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgb(246, 152, 105)',
  },
  '&:disabled': {
    backgroundColor: colors.btnDisabled,
  },
  overrideFontSizeForMobile: '16px !important',
};

export const maskTextStyles = {
  '-webkit-user-select': 'none',
  '-moz-user-select': 'none',
  '-ms-user-select': 'none',
  'user-select': 'none',
  color: 'transparent !important',
};
